var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A7E8A",
    d: "M29.436 6.285H9.468v6.273h22.464v15.054h8.736V6.285h-4.992V.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AED8DE",
    d: "M.668 12.412V33.74H5.66v6.272l6.24-6.272h19.968v-6.273H9.404V12.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2E",
    d: "M23.868 21.212h1.2v-1.2h-1.2zM21.068 21.212h1.2v-1.2h-1.2zM17.868 21.212h1.2v-1.2h-1.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/Talk.0f219d27f6b3c88447d5cbab58f8d0dd.svg";
export { ForwardRef as ReactComponent };